export enum DiscountCodeStatusType {
    Initial,
    Submitting,
    Success,
    Error,
}

export interface DiscountCodeStatus {
    type: DiscountCodeStatusType;
    message: string | null;
}
